<template>
    <div :class="`x-query-view ${showDefaultQuery ? '': 'expanded'}`" @keydown.enter="query()">
        <div class="x-query-default" v-if="showExtQuery && defaultQuerys.length">
            <span class="title">常用查询</span>
            <el-tag
                v-for="(query, index) in defaultQuerys"
                :key="index"
                class="mx-1"
                :closable="!readonly"
                :disable-transitions="false"
                @click="handlerClick(query)"
                @close="handleClose(query)"
            >
                {{ query.name }}
            </el-tag>
        </div>
        <x-form ref="form"
            :config="getConfig(config, showDefaultQuery)"
            :readonly="readonly"
            :data="queryData"
            :rules="getRules(config?.fields, showDefaultQuery)"
            @button-click="buttonClickHandler"
        ></x-form>
        <div v-if="hasExpand" class="expander" @click="showDefaultQuery = !showDefaultQuery">
            <el-icon class="expand-bar" size="small"><ArrowDown/></el-icon><el-icon class="expand-bar" size="small"><ArrowDown/></el-icon><el-icon class="expand-bar" size="small"><ArrowDown/></el-icon> 
            <span style="font-size:12px; color: #AAA">{{showDefaultQuery ? '展开' : '收起'}}</span>
            <el-icon class="expand-bar" size="small"><ArrowDown/></el-icon><el-icon class="expand-bar" size="small"><ArrowDown/></el-icon><el-icon class="expand-bar" size="small"><ArrowDown/></el-icon>
        </div>
    </div>
</template>
<script setup>
import { computed, getCurrentInstance, onMounted, ref, watch } from 'vue';
import { Search, Refresh, ArrowDown, Plus } from '@element-plus/icons-vue';
import FieldType from '../datamodule/FieldType';
import ActionType from '../actions/ActionType';
import XForm from '../components/data/XForm.vue';
import ViewState from './ViewState';
import { ElMessageBox } from 'element-plus';
import { useRoute } from 'vue-router';
import ValidateRules from '../rules/ValidateRules';
import ModuleCenter from '../datamodule/ModuleCenter';

const inst = getCurrentInstance();

const DEFAULT_FIELD_COUNT = 8;
const DEF_QUERY_BUTTONS_FIELD = {
    type:FieldType.BUTTON, field:'options', width:24, buttons:[
        {code:ActionType.QUERY, name:'查询', icon:Search},
        {code:ActionType.RESET, name:'重置', type:'default', icon:Refresh},
    ], grouped:false
}

const props = defineProps({
    config: { default: null },
    readonly: { default: false },
    queryParams: { default: null },
    data: { default: null },
    filterData: { default: null },
    proxy: { default: null },
    pcode: { default: null },

    showExtQuery: { default: false },
})

const route = useRoute();

const rules = ref(null);
const queryData = ref({});

const routeQuery = Object.assign({}, route.query);
const q = {};
for (let i in routeQuery) {
    if (i == 'tab' || i == 'state' || i == 'token') continue;
    let value = routeQuery[i];
    if (value instanceof Array) value = value.join(',');
    value = value.split(/\,/);
    if (value && value.length == 1) value = value[0];
    q[i] = value;
}
const qry = Object.assign({}, q, props.queryParams?.query, props.config?.default?.query);
const opt = Object.assign({}, props.queryParams?.options, props.config?.default?.options);
if (qry) {
    const fm = {};
    for (const field of props.config?.fields) {
        const f = field.field;
        fm[f] = 1;
        if (qry[f] && (!opt[f] || opt[f] == 'like') && field.path && field.path.length) {
            const df = field.path[field.path.length - 2].field;
            const q = qry[f];
            let filter = '';
            const module = df.getModule();
            let singleData = null;
            if (q instanceof Array) {
                filter = df._relFieldCode + ' in ' + JSON.stringify(q);
                if (q.length == 1) singleData = module.getKey(q[0]);
            } else {
                filter = df._relFieldCode + ' = ' + JSON.stringify(q);
                singleData = module.getKey(q);
            }
            field.pathFilter = filter;
            if (singleData) {
                singleData.then((value)=> {
                    queryData.value[f] = value;
                    setTimeout(()=> query(), 100);
                })
            }
        }
    }
    for (const [f, v] of Object.entries(qry)) {
        if (!fm[f] && (!opt[f] || opt[f] =='like')) queryData.value[f] = v;
    }
}
props.config.default = {query:qry, options:opt};

props.queryParams.query = Object.assign({}, props.config?.default?.query);

const hashPath = /\#([\w\/]+)/.test(window.location.href) ? RegExp.$1 : '';
const queryPath = ':q-' + hashPath + '/' + props.pcode;

const defaultQuerys = ref(JSON.parse(localStorage.getItem(queryPath) || '[]'))
const saveDefaultQuerys = ()=> {
    const querys = defaultQuerys.value;
    window.localStorage.setItem(queryPath, JSON.stringify(querys));
}
const handleClose = async (query)=> {
    if ((await ElMessageBox.confirm('是否删除常用查询条件？', '提示：', { confirmButtonText: '是', cancelButtonText: '否', type: 'warning' })) == 'cancel') return;
    const querys = defaultQuerys.value;
    querys.splice(querys.indexOf(query), 1);
    defaultQuerys.value = querys;
    saveDefaultQuerys();
}
const handlerClick = (q)=> {
    queryData.value = Object.assign({}, q.queryData);
    query();
}
const addDefaultQuery = async ()=> {
    if (defaultQuerys.value.length >= 5) {
        ElMessageBox.alert('只能存储5个常用查询条件，请先删除其它条件。', '提示：', {confirmButtonText:'确定', type:'warning'});
        return;
    }
    const date = new Date();
    ElMessageBox.prompt('名称', '添加常用查询条件：', { inputValue:date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate() + ' ' + date.getHours() + ':' + date.getMinutes() + ':' + date.getSeconds(), confirmButtonText: '确定', cancelButtonText: '取消' }).then((res)=> {
        const data = Object.assign({}, queryData.value);
        const querys = defaultQuerys.value;
        querys.push({name:res.value, queryData:data});
        defaultQuerys.value = querys;
        saveDefaultQuerys();
    }).catch(()=> {})
}

defineEmits({
    query: null,
})

const showDefaultQuery = ref(true);
const hasExpand = ref(true);

const updateNodeData = ()=> {
    const node = props.config?.node;
    if (!node) return;
    node.setNodeData({query:props.queryParams.query, queryOptions:props.queryParams.options})
}
const getNodeData = ()=> {
    const node = props.config?.node;
    if (!node) return null;
    return node.getNodeData();
}

const getRules = (fields, showDefault)=> {
    if (fields) return [];
    const fs = [];
    for (const field of fields) {
        const f = Object.assign({}, field);
        if (f.type == FieldType.DATE) {
            f.type = FieldType.DATERANGE;
            f.width = 12;
        } else if (f.type == FieldType.DATETIME) {
            f.type = FieldType.DATETIMERANGE;
            f.width = 12;
        }
        fs.push(f);
    }
    fields = showDefault ? getDefaultFields(fs, props.config.withDefaultButtons) : getFields(fs, props.config.withDefaultButtons);
    return ValidateRules.getRules(fields);
}

const getConfig = (config, showDefault)=> {
    const conf = {...config};
    config.labelWidth = 'null';

    const fs = [];
    for (const field of props.config.fields) {
        const f = Object.assign({}, field);
        if (f.type == FieldType.DATE) {
            f.type = FieldType.DATERANGE;
            f.width = 12;
        } else if (f.type == FieldType.DATETIME) {
            f.type = FieldType.DATETIMERANGE;
            f.width = 12;
        }
        fs.push(f);
    }
    const fields = showDefault ? getDefaultFields(fs, props.config.withDefaultButtons) : getFields(fs, props.config.withDefaultButtons);

    conf.fields = fields;
    return conf;
}
props.config.itemWidth = 6;
const getDefaultFields = (fields, withDefaultButtons)=> {
    const fs = fields;
    
    const def = [];
    const dfs = [];
    const expand = false;
    for (const field of fields) {
        if (field.default) {
            def.push(field.field);
        }
    }
    if (!def.length) {
        for (const field of fields) {
            def.push(field.field);
            if (def.length >= DEFAULT_FIELD_COUNT) break;
        }
    }
    hasExpand.value = def.length < fs.length;
    if (!withDefaultButtons) return fs;
    let buttonField = null;
    for (let i = 0; i < fs.length; i++) {
        const field = fs[i];
        if (field.type == FieldType.BUTTON) buttonField = field;
        else if (def.indexOf(field.field) >= 0) dfs.push(field);
    }
    if (buttonField) {
        buttonField.buttons = buttonField.buttons.concat(DEF_QUERY_BUTTONS_FIELD.buttons);
        if (props.showExtQuery) buttonField.buttons.push({code:'addDefaultQuery', icon:Plus, name:'常用', type:'default'});
    } else {
        buttonField = Object.assign({}, DEF_QUERY_BUTTONS_FIELD);
        if (props.showExtQuery) buttonField.buttons = buttonField.buttons.concat({code:'addDefaultQuery', icon:Plus, name:'常用', type:'default'});
        dfs.push(buttonField);
    }
    // hasExpand.value = dfs.length > fs.length + 1;
    return dfs;
}
const getFields = (fields, withDefaultButtons)=> {
    const fs = fields;
    if (!withDefaultButtons) return fs;
    let buttonField = null;
    for (let i = 0; i < fs.length; i++) {
        const field = fs[i];
        if (field.type == FieldType.BUTTON) buttonField = field;
    }
    if (buttonField) {
        buttonField.buttons = buttonField.buttons.concat(DEF_QUERY_BUTTONS_FIELD.buttons);
        if (props.showExtQuery) buttonField.buttons.push({code:'addDefaultQuery', icon:Plus, name:'常用', type:'default'});
    } else {
        buttonField = Object.assign({}, DEF_QUERY_BUTTONS_FIELD);
        if (props.showExtQuery) buttonField.buttons = buttonField.buttons.concat({code:'addDefaultQuery', icon:Plus, name:'常用', type:'default'});
        fs.push(buttonField);
    }
    return fs;
}

const fillData = async(query)=> {
    if (!dataView.value) return null;
    const data = await dataView.value?.fillData(query, ViewState.QUERY);
    return data;
}

const dataView = ref(null);
watch(()=> props.config?.view, (value)=> {
    dataView.value = value;
}, {immediate:true})

// watch(()=> props.config?.view, (value)=> {
//     dataView.value = ViewCenter.getView(value);
//     props.config.fields = getFields(dataView.value?.getViewFields(), props.config.withDefaultButtons);
// }, {immediate:true})

const autoSearch = computed(()=> {
    return !(props.config.buttons && props.config.buttons.length || props.config.withDefaultButtons);
})
const getQueryData = async (query, autoSearch) => {
    if (autoSearch) return await fillData(query);
    Object.assign(queryData.value, await fillData(query));
    return queryData.value;
}

const getTreeValues = (data, field, res)=> {
    if (!res) res = [];
    res.push(data[field]);
    if (data.children) {
        for (const child of data.children) {
            getTreeValues(child, field, res);
        }
    }
    return res;
}
const getValue = (data, field)=> {
    if (props.filterData?.withChildren) {
        return getTreeValues(data, field);
    } else {
        return data[field]
    }
}
const toStringArray = (value)=> {
    if (!value) return [];
    if (value instanceof Array) {
        return value.map((v)=> {
            if (!v) return '';
            return '' + v;
        })
    } else {
        return ['' + value];
    }
}

const query = ()=> {
    props.queryParams.query = Object.assign({}, props.config?.default?.query, queryData.value);
    let filterOptions = null;
    if (props.filterData && props.filterData.data) {
        const filter = props.filterData.data;
        const path = [props.filterData.module, dataView.value.getModuleCode()];
        const relations = ModuleCenter.testRelations(path);
        if (relations.length > 1) {
            const p = [];
            for (let i = 0; i < relations.length - 1; i++) {
                const {dest} = relations[i];
                const {src} = relations[i + 1];
                let srcField = null;
                let module = null;
                let destField = null;
                dest.replace(/^(\w+)\.(\w+)$/, ($0, $1, $2)=> {
                    module = $1;
                    srcField = $2;
                })
                src.replace(/^\w+\.(\w+)$/, ($0, $1)=> {
                    destField = $1;
                })
                p.push(destField);
                p.push(module);
                p.push(srcField);
            }
            let field = '';
            let key = '';
            relations[0].src.replace(/^\w+\.(\w+)$/, ($0, $1)=> {
                field = $1;
            })
            relations[relations.length - 1].dest.replace(/^\w+\.(\w+)$/, ($0, $1)=> {
                key = $1;
            })
            const v = getValue(filter, field);
            if (v == null) {
                delete props.filterData.data[field];
                delete props.queryParams.query[key];
                if (props.queryParams.options) delete props.queryParams.options[key];
            } else {
                props.queryParams.query[key] = [p, toStringArray(v)];
                if (!props.queryParams.options) props.queryParams.options = {};
                if (!filterOptions) filterOptions = {};
                filterOptions[key] = 'multi-relate';
                props.queryParams.options[key] = 'multi-relate';
            }
        } else if (relations.length == 1) {
            let field = '';
            let key = '';
            relations[0].src.replace(/^\w+\.(\w+)$/, ($0, $1)=> {
                field = $1;
            })
            relations[relations.length - 1].dest.replace(/^\w+\.(\w+)$/, ($0, $1)=> {
                key = $1;
            })
            const v = getValue(filter, field);
            if (v == null) {
                delete props.filterData.data[field];
                delete props.queryParams.query[key];
            } else {
                props.queryParams.query[key] = v;
            }
        } else {
            const module = dataView.value.getModule();
            const relation = module.getModuleRelation(module.getCode());
            if (relation) {
                props.queryParams.query[relation.destField] = filter[relation.srcField];
            } else {
                for (const [k, v] of Object.entries(filter)) {
                    props.queryParams.query[k] = getValue(filter, k);
                }
            }
        }
    }
    const options = Object.assign({}, props.config?.default?.options, filterOptions);
    const fields = props.config.fields;
    for (const field of fields) {
        if (field.type == FieldType.INPUT && queryData.value[field.field] != null) {
            options[field.field] = "like";
        } else if (field.type == FieldType.DATE || field.type == FieldType.DATETIME) {
            options[field.field] = 'range';
        } else if (field.type == FieldType.INPUTSECTION) {
            options[field.field] = 'range';
        }
    }
    // props.queryParams.query['_t'] = Math.floor(Date.now() / 1000);
    props.queryParams.options = options;
    if (props.config.ignoredFields) {
        for (const f of props.config.ignoredFields) {
            delete props.queryParams.query[f];
        }
    }
    updateNodeData();
    props.proxy?.onQuery(dataView.value.getCode() || dataView.value.getModuleCode(), getNodeData());
    inst.emit('query', props.queryParams);
}
const reset = ()=> {
    inst.refs.form['resetForm']();
    queryData.value = {};
    query();
}

const buttonClickHandler = (button)=> {
    switch (button.action || button.code) {
        case ActionType.QUERY: query(); break;
        case ActionType.RESET: reset(); break;
        case 'addDefaultQuery': addDefaultQuery(); break;
    }
}

onMounted(()=> {
    getQueryData(props.queryParams?.query, autoSearch);
})

</script>
<style scoped>
.x-query-view {
    background: #fff;
    margin-top: 10px;
}
.x-query-view > .x-query-default > span.title {
    font-size: 14px;
    color: #666;
    margin: 0 20px;
}
.x-query-view > .x-query-default > span.mx-1 {
    margin: 4px;
}
.x-query-view > .x-query-default >>> .el-tag {
    cursor: pointer;
}
.x-query-view > .x-query-default >>> .el-tag__content {
    min-width: 20px;
}
.x-query-view >>> .el-form-item {
    margin: 0 !important;
}
.x-query-view >>> .el-icon {
    font-size: small;
    transition: 400ms;
}
.x-query-view >>> .expander {
    cursor: pointer;
    line-height: 10px;
    text-align: center;
    background: #f5f7fa;
}
.x-query-view.expanded >>> .el-icon.expand-bar {
    transform: rotate(180deg);
}

.x-query-view >>> .el-form-item__label {
    width: auto !important;
}

.x-query-view >>> .el-form-item__content {
    justify-content: center;
}
</style>